import React from "react";
import { InputPropsWithoutRef } from "react-html-props";
import { twMerge } from "tailwind-merge";

export interface ITextInputProps extends InputPropsWithoutRef {}

export const TextInput = React.forwardRef<any, ITextInputProps>(
  ({ ...props }, ref) => (
    <input
      {...props}
      className={twMerge(
        "w-full mx-auto rounded-lg border-black/10 border-2 p-3 focus:border-blue-600/20 focus:outline-none",
        props.className
      )}
      ref={ref}
    />
  )
);

export default TextInput;
